import { PATHS } from '@app/data/paths';
import { TASK_CONFIG, TASK_STATUSES, type TaskBaseStatusEnum } from '@app/data/tasks/constants';
import { getUserFullName } from '@repo/utils';
import { Flex, Typography } from 'antd';
import clsx from 'clsx';

import styles from './TaskSubjectRenderer.module.scss';

export default function TaskSubjectRenderer({
  subject,
  status,
  leadUuid,
  firstName,
  lastName,
} : {
  subject: string;
  status: TaskBaseStatusEnum;
  leadUuid: string;
  firstName: string;
  lastName: string;
}) {
  const subjectTextType = (
    status === TASK_STATUSES.cancelled || status === TASK_STATUSES.completed
  ) ? 'secondary' : undefined;

  return (
    <Flex gap="small" className={styles.container}>
      <div className={clsx(styles.divider, styles[TASK_CONFIG[status].dividerClassName as any])} />
      <Flex align="flex-start" vertical>
        <Typography.Text
          type={subjectTextType}
          delete={
            status === TASK_STATUSES.cancelled
          || status === TASK_STATUSES.completed
          }
        >
          {subject}
        </Typography.Text>
        <Typography.Link href={PATHS.leadDetail(leadUuid)} target="_blank">
          {`Lead: ${getUserFullName({
            firstName,
            lastName,
          })}`}
        </Typography.Link>
      </Flex>
    </Flex>
  );
}
